const FinEaseHomeRoutes = {
  FIN_EASE_HOME: "/",
  ADMIN: "/admin-login",
  ADMIN_DASHBOARD: "/admin-dashboard",
  DASHBOARD: "/dashboard",
  NPS_USER_LIST: "/user-list",
  NPS_USER_DETAILS: (id: string) => `/user-list/${id}`,
  NPS_USER_DETAILS_ROUTE: "/user-list/:id",
  ACTIVITY_LOG: "/activity-log",
  PAYMENT_ENTRY: "/payment-entry",
} as const;

export default FinEaseHomeRoutes;
